module.exports = __webpack_public_path__ + "media/images/cleaning/pro2@3x-5d8ba3fc2ef76f7dc43fdaca37e5a4bf.jpg";